module.exports = __webpack_public_path__ + "img/homebg.6dea874b.jpg";